import { Product, Property, PropertyGroup } from '../typings/types';

export const groupByTitle = (propertyGroups: PropertyGroup[], title: string) =>
  propertyGroups.find(propertyGroup => propertyGroup?.title === title) ?? { properties: [] };

export const propertyByProductIdAndPropertyId = (
  products: Product[],
  productId: number,
  propertyId: string
): Property | null => {
  const product = products.find(productDataItem => productDataItem?.id === productId);
  if (!product) {
    return null;
  }
  const properties = product?.properties?.propertyGroups?.flatMap(
    propertyGroup => propertyGroup.properties
  );

  return properties?.find(property => property.propertyId === propertyId) ?? null;
};

export const extractPropertyGroups = (productData: Product[]): PropertyGroup[] =>
  productData
    .flatMap(product =>
      product.properties.propertyGroups.length > 0
        ? product.properties.propertyGroups
        : product.subProducts?.[0]?.product.properties.propertyGroups
    )
    .filter(Boolean) as PropertyGroup[];

export const getUniqueTitles = (propertyGroups: PropertyGroup[]): string[] => {
  return Array.from(new Set(propertyGroups.map(propertyGroup => propertyGroup?.title ?? '')));
};
